import { STOCK_STATE_LABELS } from '../../utils/inventoryLabels';

/** Sentinel of a select filter that is not narrowing anything. */
export const ALL_FILTER = 'all';

/**
 * The two ways of looking at the same stock. Consolidated answers "how much do
 * I have of this" and is the one opened every day; the detail answers "where
 * is it" and is the tool for going to fetch it.
 */
export const STOCK_VIEW = {
  CONSOLIDATED: 'consolidated',
  DETAIL: 'detail',
};

/** How the server is asked to consolidate. No grouping is the detail. */
export const STOCK_GROUP_BY = {
  SKU: 'sku',
  SKU_LOT: 'sku_lot',
};

export const EMPTY_STOCK_TOTALS = { available: 0, reserved: 0, picked: 0, total: 0 };

export const STOCK_STATE_OPTIONS = [
  { value: ALL_FILTER, label: 'Todos' },
  ...Object.entries(STOCK_STATE_LABELS).map(([value, label]) => ({ value, label })),
];
